export default {
  title: '¡Únete a {{name}}!',
  default_program_name: 'Club de recompensas',
  savings_highlight: {
    title: 'Gana recompensas. En cada pedido, siempre.',
    subtitle: 'Regístrate en segundos y empieza a ganar puntos.',
  },
  how_it_works: {
    label: 'Cómo funciona',
    step_1: {
      title: 'Regístrate en 30 s',
      desc: 'Solo tu número de teléfono',
    },
    step_2: {
      title: 'Pide y gana',
      desc: '{{percentage}}% de vuelta en cada pedido',
    },
    step_3: {
      title: 'Canjea y ahorra',
      desc: 'Hasta {{amount}} de descuento por pedido',
    },
  },
  profile: {
    verified_title: '¡Teléfono verificado!',
    verified_subtitle: 'Completa tu perfil para empezar a ganar.',
  },
  form: {
    phone_number: {
      label: 'Número de teléfono',
      description: 'Enviaremos un código de verificación para confirmar tu identidad.',
      placeholder: 'Número de teléfono',
    },
    birthday: {
      label: 'Cumpleaños — con día y mes es suficiente para recibir un regalo 🥳',
      placeholder: 'Cumpleaños (opcional)',
      parts: {
        month: 'Mes',
        day: 'Día',
      },
    },
  },
  terms:
    'Al registrarte, aceptas nuestros <TermsLink>términos y condiciones</TermsLink> y consientes nuestra <PrivacyPolicyLink>política de privacidad</PrivacyPolicyLink>.',
  buttons: {
    continue: 'Continuar',
    verify: 'Verificar',
    complete: 'Completar registro',
  },
  toasts: {
    login_success: 'Has iniciado sesión correctamente',
    invalid_code: 'Código inválido. Por favor, inténtalo de nuevo.',
    failed_to_update_profile: 'Error al actualizar el perfil. Por favor, inténtalo de nuevo.',
  },
};
